import { Injectable } from '@angular/core';

/**
 * @deprecated This service is deprecated and should not be used.
 * Use CashoutGrpcService or other specific gRPC services directly.
 *
 * The old WebSocket-based implementation has been replaced with proper gRPC-Web
 * using @improbable-eng/grpc-web and Protocol Buffers.
 *
 * See CashoutGrpcService for the correct implementation pattern.
 */
@Injectable({
  providedIn: 'root',
})
export abstract class GrpcGatewayService {
  constructor() {
    console.warn(
      '[GrpcGatewayService] This service is deprecated. Use specific gRPC services instead.',
    );
  }
}
